__turbopack_context__.v({
  "active": "PurchaseFlow-module__gokFGa__active",
  "activeCryptoCard": "PurchaseFlow-module__gokFGa__activeCryptoCard",
  "activeInputMode": "PurchaseFlow-module__gokFGa__activeInputMode",
  "activeStepContainer": "PurchaseFlow-module__gokFGa__activeStepContainer",
  "activeToggle": "PurchaseFlow-module__gokFGa__activeToggle",
  "address": "PurchaseFlow-module__gokFGa__address",
  "amountInput": "PurchaseFlow-module__gokFGa__amountInput",
  "amountInputContainer": "PurchaseFlow-module__gokFGa__amountInputContainer",
  "amountInputField": "PurchaseFlow-module__gokFGa__amountInputField",
  "amountInputWrapper": "PurchaseFlow-module__gokFGa__amountInputWrapper",
  "backButton": "PurchaseFlow-module__gokFGa__backButton",
  "button": "PurchaseFlow-module__gokFGa__button",
  "buttonContainer": "PurchaseFlow-module__gokFGa__buttonContainer",
  "checkmark": "PurchaseFlow-module__gokFGa__checkmark",
  "completed": "PurchaseFlow-module__gokFGa__completed",
  "conversionResult": "PurchaseFlow-module__gokFGa__conversionResult",
  "cryptoButton": "PurchaseFlow-module__gokFGa__cryptoButton",
  "cryptoCard": "PurchaseFlow-module__gokFGa__cryptoCard",
  "cryptoCardsGrid": "PurchaseFlow-module__gokFGa__cryptoCardsGrid",
  "cryptoIcon": "PurchaseFlow-module__gokFGa__cryptoIcon",
  "cryptoIconContainer": "PurchaseFlow-module__gokFGa__cryptoIconContainer",
  "cryptoInfo": "PurchaseFlow-module__gokFGa__cryptoInfo",
  "cryptoList": "PurchaseFlow-module__gokFGa__cryptoList",
  "cryptoName": "PurchaseFlow-module__gokFGa__cryptoName",
  "cryptoPrice": "PurchaseFlow-module__gokFGa__cryptoPrice",
  "cryptoTicker": "PurchaseFlow-module__gokFGa__cryptoTicker",
  "currencyWithIcon": "PurchaseFlow-module__gokFGa__currencyWithIcon",
  "detailLabel": "PurchaseFlow-module__gokFGa__detailLabel",
  "detailRow": "PurchaseFlow-module__gokFGa__detailRow",
  "detailValue": "PurchaseFlow-module__gokFGa__detailValue",
  "disconnectButton": "PurchaseFlow-module__gokFGa__disconnectButton",
  "error": "PurchaseFlow-module__gokFGa__error",
  "errorBox": "PurchaseFlow-module__gokFGa__errorBox",
  "errorInput": "PurchaseFlow-module__gokFGa__errorInput",
  "errorMessage": "PurchaseFlow-module__gokFGa__errorMessage",
  "fadeIn": "PurchaseFlow-module__gokFGa__fadeIn",
  "formGroup": "PurchaseFlow-module__gokFGa__formGroup",
  "highlight": "PurchaseFlow-module__gokFGa__highlight",
  "highlightSmall": "PurchaseFlow-module__gokFGa__highlightSmall",
  "infoBox": "PurchaseFlow-module__gokFGa__infoBox",
  "input": "PurchaseFlow-module__gokFGa__input",
  "inputCurrency": "PurchaseFlow-module__gokFGa__inputCurrency",
  "inputLabel": "PurchaseFlow-module__gokFGa__inputLabel",
  "inputModeCheck": "PurchaseFlow-module__gokFGa__inputModeCheck",
  "inputModeDivider": "PurchaseFlow-module__gokFGa__inputModeDivider",
  "inputModeIcon": "PurchaseFlow-module__gokFGa__inputModeIcon",
  "inputModeLabel": "PurchaseFlow-module__gokFGa__inputModeLabel",
  "inputModeOption": "PurchaseFlow-module__gokFGa__inputModeOption",
  "inputModeSwitcher": "PurchaseFlow-module__gokFGa__inputModeSwitcher",
  "inputToggle": "PurchaseFlow-module__gokFGa__inputToggle",
  "loading": "PurchaseFlow-module__gokFGa__loading",
  "orderDetailsList": "PurchaseFlow-module__gokFGa__orderDetailsList",
  "orderDetailsSection": "PurchaseFlow-module__gokFGa__orderDetailsSection",
  "orderDetailsTitle": "PurchaseFlow-module__gokFGa__orderDetailsTitle",
  "paymentDetails": "PurchaseFlow-module__gokFGa__paymentDetails",
  "priceInfoContainer": "PurchaseFlow-module__gokFGa__priceInfoContainer",
  "pricePlaceholder": "PurchaseFlow-module__gokFGa__pricePlaceholder",
  "purchaseButton": "PurchaseFlow-module__gokFGa__purchaseButton",
  "purchaseContainer": "PurchaseFlow-module__gokFGa__purchaseContainer",
  "purchaseFlowContainer": "PurchaseFlow-module__gokFGa__purchaseFlowContainer",
  "purchaseStep": "PurchaseFlow-module__gokFGa__purchaseStep",
  "resultBox": "PurchaseFlow-module__gokFGa__resultBox",
  "resultLabel": "PurchaseFlow-module__gokFGa__resultLabel",
  "resultValue": "PurchaseFlow-module__gokFGa__resultValue",
  "saftAgreementButton": "PurchaseFlow-module__gokFGa__saftAgreementButton",
  "selectedCheckmark": "PurchaseFlow-module__gokFGa__selectedCheckmark",
  "selectedCryptoCard": "PurchaseFlow-module__gokFGa__selectedCryptoCard",
  "shakeError": "PurchaseFlow-module__gokFGa__shakeError",
  "spin": "PurchaseFlow-module__gokFGa__spin",
  "spinner": "PurchaseFlow-module__gokFGa__spinner",
  "step": "PurchaseFlow-module__gokFGa__step",
  "stepCircle": "PurchaseFlow-module__gokFGa__stepCircle",
  "stepDescription": "PurchaseFlow-module__gokFGa__stepDescription",
  "stepHeader": "PurchaseFlow-module__gokFGa__stepHeader",
  "stepLabel": "PurchaseFlow-module__gokFGa__stepLabel",
  "stepNumber": "PurchaseFlow-module__gokFGa__stepNumber",
  "stepSection": "PurchaseFlow-module__gokFGa__stepSection",
  "stepTitle": "PurchaseFlow-module__gokFGa__stepTitle",
  "steps": "PurchaseFlow-module__gokFGa__steps",
  "successInput": "PurchaseFlow-module__gokFGa__successInput",
  "successMessage": "PurchaseFlow-module__gokFGa__successMessage",
  "toggleButton": "PurchaseFlow-module__gokFGa__toggleButton",
  "tokenInfo": "PurchaseFlow-module__gokFGa__tokenInfo",
  "totalRow": "PurchaseFlow-module__gokFGa__totalRow",
  "transactionConfirmed": "PurchaseFlow-module__gokFGa__transactionConfirmed",
  "transactionHash": "PurchaseFlow-module__gokFGa__transactionHash",
  "transactionPending": "PurchaseFlow-module__gokFGa__transactionPending",
  "walletAddress": "PurchaseFlow-module__gokFGa__walletAddress",
  "walletConnectionArea": "PurchaseFlow-module__gokFGa__walletConnectionArea",
  "walletInfo": "PurchaseFlow-module__gokFGa__walletInfo",
  "walletStep": "PurchaseFlow-module__gokFGa__walletStep",
});
